import api from '../../../api/api';

export default {
  getAggregateData: async (data, agencyId) => {
    return api.get(
      `/api/v1/social/metrics/accounts/aggregate/?${Object.keys(data).reduce(
        (res, key) => `${res}${res ? '&' : ''}${key}=${data[key]}`,
        ''
      )}`,
      { headers: { 'x-agency-id': agencyId } },
    );
  },
};
